import { render, staticRenderFns } from "./VBTable.vue?vue&type=template&id=13420a1e&scoped=true&"
import script from "./VBTable.vue?vue&type=script&lang=js&"
export * from "./VBTable.vue?vue&type=script&lang=js&"
import style0 from "./VBTable.vue?vue&type=style&index=0&id=13420a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13420a1e",
  null
  
)

export default component.exports